<template>
	<div>
		<CubePage type="myorder-view" title="年龄段统计">
			<div slot="content" class="content">
				<div class="main">
					<div class="tbox datalist">
						<div id="mainPre" ref="mainPre" style="width: 100%;height:120px;"></div>
						<div class="tbox-list">
							<div class="flex " v-for=" (item,index) in listObj">
								<div class="l-date">
									{{item.name}}
								</div>
								<div class="r-num">
									{{item.value}}人
								</div>
							</div>
						</div>
					</div>
					<div class="datalist">
						<div id="agePre" ref="agePre" style="width: 100%;height:120px;"></div>
					</div>
					<div class="datalist">
						<div id="agesPre" ref="agesPre" style="width: 100%;height:220px;"></div>
					</div>
					<div class="datalist">
						<div id="agesBar" ref="agesBar" style="width: 100%;height:180px;"></div>
					</div>
					<!-- <img src="@/assets/echartsImg/et.png" alt="" srcset=""> -->
				</div>
			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import * as echarts from 'echarts';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				listObj: null,
				nnData: null
			}
		},
		created() {
			this.ageSearch()
			this.onSearch()
			this.onNSearch()
		},
		methods: {
			// initht() {
			// 	this.$nextTick(() => {
			// 		this.initBt()
			// 		this.initAge()
			// 		this.initAges()
			// 		this.initBar()
			// 	})
			// },
			initBt(data) {
				var chartDom = document.getElementById('mainPre');
				var myChart = echarts.init(chartDom);
				console.log(echarts)
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '游客年龄段',
						left: 'center',
						textStyle: {
							color: '#00ffff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center',
						show: false
					},
					series: [{
						top: 25,
						name: '游客年龄段',
						type: 'pie',
						radius: ['30%', '50%'],
						avoidLabelOverlap: false,
						data: data,
						label: {
							color: '#fff',
							formatter: `{b}\n{d}%`,
						}
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function() {
					myChart.resize()
				}
			},
			initAge(data) {
				var chartDom = document.getElementById('agePre');
				var myChart = echarts.init(chartDom);
				console.log(echarts)
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '游客男女比例',
						left: 'center',
						textStyle: {
							color: '#00ffff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center',
						show: false
					},
					series: [{
						top: 20,
						name: '游客年龄段',
						type: 'pie',
						radius: '50%',
						avoidLabelOverlap: false,
						data: data,
						label: {
							color: '#fff',
							formatter: `{b}\n{d}%`,
						}
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function() {
					myChart.resize()
				}
			},
			initAges(data) {
				var chartDom = document.getElementById('agesPre');
				var myChart = echarts.init(chartDom);
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '游客年龄段',
						left: 'center',
						textStyle: {
							color: '#00ffff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						right: 5,
						bottom: 5,
						itemWidth: 5,
						itemHeight: 5,
						textStyle: {
							color: '#fff'
						}
					},
					series: [{
						top: 20,
						name: '游客年龄段',
						type: 'pie',
						radius: '80%',
						right: '100',
						data: data,
						label: {
							position: 'inner',
							formatter: `{d}%`,
							color: '#fff'
						}
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function() {
					myChart.resize()
				}
			},
			initBar(data) {
				var chartDom = document.getElementById('agesBar');
				var myChart = echarts.init(chartDom);
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '游客年龄',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff'
					},
					xAxis: {
						type: 'category',
						data: data.groups,
						axisLabel: {
							color: '#fff',
							rotate: 40
							// formatter: function(value) {
							// 	let b=value.substr(0,3)
							// 	let a=value.substr(3,value.length)
							// 	// if(value == 'Mon'){
							// 	return b+`\n` + a;
							// 	// }
							// },
							// rich: {
							// 	//这里的rich，下面有解释
							// 	Mon: {
							// 		//这里的warnValue对应上面的标签名
							// 		height: 10,
							// 		align: 'center',
							// 		backgroundColor: {
							// 			image: "@/assets/echartsImg/et.png" //这个warnImg是上面定义的图片var warnImg = "img/warn.png";
							// 		}
							// 	}
							// }
						}
					},
					yAxis: {
						show: false
					},
					series: [{
						data: data.array,
						type: 'bar',
						itemStyle: {
							color: '#55aa7f'
						},
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function() {
					myChart.resize()
				}
			},
			async onSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getAgeGroupList"
				//这里直接调用网络接口
				await util.post(url, {},
					function(result) {
						that.initAges(result.data.list)
						that.initBar({
							groups: result.data.groups,
							array: result.data.array
						})
					},
				);
			},
			async onNSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getSexGroupList"
				//这里直接调用网络接口
				await util.post(url, {},
					function(result) {
						that.initAge(result.data.list)
					},
				);
			},
			async ageSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getAgeGroupData"
				//这里直接调用网络接口
				await util.post(url, {},
					function(result) {
						that.listObj = result.data.list
						that.initBt(result.data.list)
					},
				);
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	.main {
		height: calc(100vh - 44px);
		overflow-x: hidden;
		overflow-y: scroll;
		background: linear-gradient(to bottom, #00557f 30%, #0072a7);

		.tbox {
			padding: 10px;

			.tbox-list {
				margin: 0 25px;
			}
		}

		.datalist {
			margin: 20px 10px;
			padding: 10px;
			border-radius: 10px;
			box-shadow: 2px 2px 10px #fafafa;

		}

		.datalist {
			text-align: center;
			line-height: 30px;
			color: #fff;

			.ii span {
				color: #ffaa00;
				font-weight: 600;
				font-size: 18px;
				padding: 0 10px;
				letter-spacing: 3px;
			}

			.flex {
				display: flex;
				justify-content: space-between;
				padding: 4px 0;

				.l-date {
					color: #00abfa;
				}

				.r-num {
					font-size: 16px;
					color: #ffff7f;
				}
			}

		}

		.wl {
			height: calc(100% - 260px);

			.scroll {
				height: calc(100% - 50px);
				overflow-y: scroll;
				overflow-x: hidden;
			}

			.scroll::-webkit-scrollbar {
				display: none;
			}

			p {
				text-align: center;
				padding: 10px;
				color: #fff;
				font-size: 20px;
			}

		}

		.header-title {
			padding: 10px;
			text-align: center;
			color: #fff;
			text-shadow: 3px 5px 5px #656B79;

			h1 {
				font-size: 18px;
			}

			h3 {
				padding-top: 6px;
				font-size: 16px;
			}
		}
	}
</style>
